// extracted by mini-css-extract-plugin
export default {"frequently_asked_questions":"FrequentlyAskedQuestions_frequently_asked_questions__pGhk6","accordeon":"FrequentlyAskedQuestions_accordeon__+5G4H"};